import { Auth } from "./Auth";
import Network from "./Network";
import { pathOr } from "ramda";

export class AgentGuardError extends Error {
	constructor(code, message) {
		super(message);
		this.code = code;
	}
};

class AgentGuard {
	constructor() {
		this.auth = new Auth();
	}

	heartBeat = async () => {
		try {
			const user = await this.auth.getUser();
			if (!user) throw new Error("User not authenticated");

			const options = {
				serviceName: "AgentGuardServiceClient",
				action: "execute",
				sessionId: user.creds.sessionId,
				params: {
					parameters: JSON.stringify({ test: "test" }),
					capability: "PingAgentGuardCapability",
					sync: true,
				},
			};

			const response = await Network(options, false);
			console.log("Connected to AgentGuard", response);
		} catch (error) {
			console.error("Error Calling AG Heartbeat:", error);
		}
	};

	/**
	 * Execute an action in AgentGuard
	 * @param {Object} params - Parameters for execution
	 * @returns {Promise<any>}
	 */
	execute = async (params) => {
		try {
			const user = await this.auth.getUser();
			if (!user) throw new Error("User not authenticated");

			const key = pathOr(null, ["conversation", "bot"], params);
			const options = {
				serviceName: "AgentGuardServiceClient",
				action: "execute",
				sessionId: user.creds.sessionId,
				params,
				key,
			};

			return await Network(options, true);
		} catch (error) {
			console.error("Error Calling Agent Guard:", error);
			throw new AgentGuardError("AG_EXECUTE_ERROR", error.message);
		}
	};
};

export default AgentGuard;
